module.exports = __webpack_public_path__ + "static/media/HL9.13ac14ef.jpg";